export default {

  "m0CheckListItemMap": {},
  "selectedM0CheckListId": -1,
  "selectedRoomId": -1,
  "selectedEditHistoryId": -1,
  "roomMastersMap": {},
  "roomDatas": [],
  "editHistoryListMap": {},
  "itemValueListHistoryMapMap": {},
  "itemFrameMapMap": {},
}